import Papa from 'papaparse'
export default {

  toCSV(objArray, filename) {
    this.downloadCSV(objArray, null, filename);
  },

  downloadCSV(objArray, mimetype, filename) {
    let data = Papa.unparse(objArray);

    if (!data) return;
    var blob = data.constructor !== Blob
      ? new Blob([data], {type: mimetype || 'application/octet-stream'})
      : data ;
  
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename);
      return;
    }
  
    var lnk = document.createElement('a'),
        url = window.URL,
        objectURL;
  
    if (mimetype) {
      lnk.type = mimetype;
    }
  
    lnk.download = filename || 'untitled';
    lnk.href = objectURL = url.createObjectURL(blob);
    lnk.dispatchEvent(new MouseEvent('click'));
    setTimeout(url.revokeObjectURL.bind(url, objectURL));
  },

  print(title, subtitle, contents, signatories, stylesheet, reportDebugMode) {
		// let width = screen.width;
		// let height = screen.height;
		// let left = (screen.width/2)-(width/2);
		// let top = (screen.height/2)-(height/2) - 50;
		let options = ''
			// + 'toolbar=no,'
			// + 'location=no,'
			// + 'directories=no,'
			// + 'status=no, menubar=no,'
			// + 'scrollbars=no,'
			// + 'resizable=no,'
			// + 'copyhistory=no,'
			// + 'width=' + width + ','
			// + 'height=' + height + ','
			// + 'top=' + top + ','
			// + 'left=' + left;

		let popupWin = window.open('Printing', '_blank', options);
		if(!popupWin) {
			alert('Please allow popups in this app and try again');
			return;
		}

		popupWin.document.open();
		popupWin.document.write(''
			+ '<html>'
			+ '<head>'
			+ '<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900">'
			+ '<link rel="stylesheet" href="../css/report-main.css">'
			+ '<link rel="stylesheet" href="../css/report-override.css">'
			+ ((stylesheet)? '<link rel="stylesheet" href="../css/report/' + stylesheet + '">' : '')
			+ '</head>'
			+ '<body>'
			+ '<img class="report-header-img d-print-only" src="../img/report-header.png"></img>'
			+ '<h1 class="d-print-none mx-auto text-center">Printing...</h1>'
			+ ((title)? '<h2 class="d-print-only report-title text-center">' + title + '</h2>' : '')
			+ ((subtitle)? '<h4 class="d-print-only report-subtitle text-center">' + subtitle + '</h4>' : '')
			+ contents
			+ this.generateFooter(signatories)
			+ '<script type="text/javascript">'
			+ ((reportDebugMode)? '' : 'setTimeout(() => { window.focus(); window.print(); }, 100);')
			+ ((reportDebugMode)? '' : 'setTimeout(function(){ window.close(); }, 2000);')
			+ '</script>'
			+ '</body>'
			+ '</html>');

		popupWin.document.close();
	},

	generateFooter(signatories) {
		if(!signatories) {
			return '';
		}

		let assigText = '';
		assigText += `<div class="signatories">`;
		signatories.forEach(signatory => {
				assigText += `
				<div class="signatory d-print-only">
					<p class="action">${signatory.action}</p>
					<p class="name">${signatory.name}</p>
					<p class="title">${signatory.title}</p>
				</div>
				`;
			});
		assigText += `</div>`;
		return assigText;
	}
}